<div class="content-wrapper">
    <ng-template #content>
        <div id="modal">
            <div class="modal-header font-weight-bold">
                <h4 class="modal-title font-weight-bold">Remove from cart - {{selectedProduct?.name}}</h4>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="modalService.dismissAll('')"
                >
                    ×
                </button>
            </div>
            <div class="modal-body">
                <div class="row p-10px">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                        <h5>
                            Are you sure you want to permanently remove <span
                                class="text-italic font-weight-bold">"{{selectedProduct?.name}}"</span> from cart ?
                        </h5>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-10px">
                <button class="btn btn-sm btn-primary color-white mr-auto" (click)="modalService.dismissAll('')">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>No
                </button>
                <button class="btn btn-sm btn-danger color-white" (click)="removeFromCart()">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
            </div>
        </div>
    </ng-template>
    <div class="content-body">
        <section id="cart">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Shopping Cart</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="quantity"
                                           placeholder="Quantity">
                                </fieldset>
                            </div>
                            <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3" *ngIf="cartProducts && cartProducts.length > 0; else noDataToShow">
                <div class="col-12">
                    <div class="card" style="zoom: 0.75">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_18 text-italic font-weight-bold">S.No.</span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_18 text-italic font-weight-bold">Remove</span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Image</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Product Name</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Quantity</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">BV</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Price</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Tax</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Tax Amount (&#8377;)</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <small class="f_18 text-italic font-weight-bold">Total</small>
                                </div>
                            </div>
                            <div class="row mt-20px shadow-top-light pt-20px"
                                 *ngFor="let cartProduct of cartProducts; let i = index">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_15 text-italic font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                        .</span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <i class="fa fa-trash f_20 text-danger cursor-pointer" aria-hidden="true"
                                       title="Remove Product"
                                       (click)="removeCartConfrimation(content, cartProduct)"></i>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <img class="border-radius-50-per"
                                         [src]="imageBaseUrl+cartProduct?.product?.image?.partial_url"
                                         width="50px" height="50px" [alt]="cartProduct?.name"/>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer">{{cartProduct?.name}}</span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto d-flex">
                                    <span>
                                        <i class="fa fa-minus-circle f_20 mt-10px mr-4px text-danger cursor-pointer"
                                           aria-hidden="true" (click)="changeItemQuantiy(cartProduct, 'MINUS')"></i>
                                    </span>

                                    <input class="form-control text-center" type="number" style="padding:2px;"
                                           [value]="cartProduct?.quantity"
                                           (blur)="updateItemQuantity($event, cartProduct)"/>
                                    <span>
                                        <i class="fa fa-plus-circle f_20 mt-10px ml-4px text-success cursor-pointer"
                                           aria-hidden="true" (click)="changeItemQuantiy(cartProduct, 'PLUS')"></i>
                                    </span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">
                                        {{((cartProduct?.basic_value) * (cartProduct?.quantity)) | IndianNumber}}
                                    </span>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">
                                        &#8377;{{cartProduct?.amount | IndianNumber}}
                                        <small>(&#8377;{{cartProduct?.distributed_price | IndianNumber}} / Unit)</small>
                                    </span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 cursor-pointer">
                                        {{cartProduct?.tax}}%
                                    </span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 cursor-pointer">
                                        &#8377;{{cartProduct?.tax_amount | IndianNumber}}
                                        <small>(&#8377;{{cartProduct?.unit_tax_amount | IndianNumber}} / Unit)</small>
                                    </span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15">&#8377;{{cartProduct?.total_amount | IndianNumber}}</span>
                                </div>
                            </div>
                            <div class="row mt-20px shadow-top-light pt-20px">
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-italic">
                                    <h4 class="mt-10px">Total Items : {{cartProducts.length}}</h4>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-italic text-center">
                                    <h4 class="mt-10px">Grand Total : &#8377;{{grandTotalAmount | IndianNumber}}</h4>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-italic text-right">
                                    <button class="btn btn-primary" (click)="checkout()">
                                        <i class="fa fa-shopping-cart f_18 mr-10px" aria-hidden="true"></i>Proceed To
                                        Checkout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-shopping-cart fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No products to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </section>
    </div>
</div>
